import { typeBool, _setNull, _getValue, createNumberList, combine } from '../common/basefn'
cb.define( ['common/common_VM.Extend.js'],function(common) {
  var AA_aa_merchant_VM_Extend = {
    doAction: function(name, viewmodel) {
      if (this[name])
        this[name](viewmodel);
    },
    init: function(viewmodel) {   	
    	// 默认隐藏渠道相关属性
    	viewmodel.get('channCustomerClass_Name').setVisible(false);
    	viewmodel.get('channCustomerLevel_Name').setVisible(false);
    	viewmodel.get('channCustomerArea_Name').setVisible(false);
    	viewmodel.get('channCustomerIndustry_Name').setVisible(false);
    	
    	viewmodel.get('enterpriseName').setState('bIsNull', true);
    	viewmodel.get('orgName').setState('bIsNull', true);
    	// 默认隐藏掉个人相关信息
      viewmodel.get('personName').setVisible(false);
      viewmodel.get('idNo').setVisible(false);
    	// 默认隐藏掉非营利组织信息
    	viewmodel.get('orgName').setVisible(false);
      viewmodel.get('personCharge').setVisible(false);
    	viewmodel.get('personChargeIdNo').setVisible(false);
    	viewmodel.get('orgIdNo').setVisible(false);
    	viewmodel.get('enterpriseName').setDisabled(true);
      viewmodel.get('orgName').setDisabled(true);
    	viewmodel.execute('updateViewMeta', { code: '客户属性信息页签', visible: false });
    	// 角色信息默认隐藏信息
    	viewmodel.get('merchantRole!settlementMethod').setVisible(false);
    	viewmodel.get('merchantRole!settlementCycle').setVisible(false);
    	viewmodel.get('merchantRole!finalSettlementDate').setVisible(false);
    	viewmodel.get('merchantRole!uMappExpireDate').setVisible(false);
    	viewmodel.get('merchantRole!businessAccount').setVisible(false);
    	viewmodel.get('merchantRole!cardOwnerName').setVisible(false);
    	viewmodel.get('merchantRole!cardType').setVisible(false);
    	viewmodel.get('merchantRole!receivingBank').setVisible(false);
      viewmodel.get('orgId_Name').setVisible(false);
      viewmodel.on('afterLoadData', (args) => {
    		common.initRegionAndPosition(viewmodel);
    			// 客户统一社会信用代码是否必输参数
      	let enterCustCreditCode = cb.rest.AppContext.option.enterCustCreditCode;
        // 个人客户身份证是否必输参数
      	let personalCustId = cb.rest.AppContext.option.personalCustId;
    		 if(enterCustCreditCode){
            viewmodel.get('creditCode').setState('bIsNull', false);	
          }else {
          	viewmodel.get('creditCode').setState('bIsNull', true);	
          }
    		checkRoleInfo(viewmodel);
    		// 适用组织页签 商家登录不显示
    	  let userType = cb.rest.AppContext.user.userType;
    		if (userType == 4 || userType == 5) {
    			  viewmodel.execute('updateViewMeta', { code: '适用组织信息页签', visible: false });
    			  viewmodel.get('orgId_Name').setVisible(false);
    			  viewmodel.get('internalOrg').setVisible(false);
    			  viewmodel.get('suppliers').setVisible(false);
    			  viewmodel.get('channCustomerClass_Name').setVisible(true);
    	      viewmodel.get('channCustomerLevel_Name').setVisible(true);
    	      viewmodel.get('channCustomerArea_Name').setVisible(true);
    	      viewmodel.get('channCustomerIndustry_Name').setVisible(true);
    	      viewmodel.get('channCustomerClass_Name').setDisabled(true);
    	      viewmodel.get('channCustomerLevel_Name').setDisabled(true);
    	      viewmodel.get('channCustomerArea_Name').setDisabled(true);
    	      viewmodel.get('channCustomerIndustry_Name').setDisabled(true);
    		}
    		// 处理客户属性信息是否显示    		
    		let lessLists=[];
    		createNumberList(30).forEach((val, i) => {
        let _free = 'customerDefine!customerDefine' + (i + 1);
        
        if (viewmodel.get(_free) && viewmodel.get(_free).getState('bShowIt') == true) {
           lessLists.push(_free);
        }
        });
        if(lessLists.length){
        	viewmodel.execute('updateViewMeta', { code: '客户属性信息页签', visible: true });
        }else{
        	viewmodel.execute('updateViewMeta', { code: '客户属性信息页签', visible: false });
        	}
        editMerchant(viewmodel);      
      	viewmodel.get('position')&&viewmodel.get('position').setState('bIsNull', true);
      });

      const editMerchant =(viewmodel)=>{
        if(!diffcreator(viewmodel)){
         viewmodel.get('code').setDisabled(true);
         viewmodel.get('name').setDisabled(true);
         viewmodel.get('shortname').setDisabled(true);
         viewmodel.get('country').setDisabled(true);
         
         viewmodel.get('channCustomerClass_Name').setDisabled(true);
         viewmodel.get('channCustomerLevel_Name').setDisabled(true);
         viewmodel.get('channCustomerArea_Name').setDisabled(true);
         viewmodel.get('channCustomerIndustry_Name').setDisabled(true);
         viewmodel.get('retailInvestors').setDisabled(true);
         viewmodel.get('internalOrg').setDisabled(true);
         viewmodel.get('orgId_Name').setDisabled(true);
         viewmodel.get('suppliers').setDisabled(true);
         viewmodel.get('creditCode').setDisabled(true)
         viewmodel.get('customerClass').setDisabled(true);
    		 viewmodel.get('customerLevel').setDisabled(true);
    		 viewmodel.get('customerArea').setDisabled(true);
    		 viewmodel.get('customerIndustry').setDisabled(true);
         viewmodel.get('leaderName').setDisabled(true)
        }
      viewmodel.get('merchantRole!toBImmigrationMode').setVisible(false);
      viewmodel.get('merchantRole!uOrderExpireDate').setVisible(false);
      viewmodel.get('orgId_Name').setVisible(false);
      // 结算周期最小是1
      viewmodel.get('merchantRole!settlementCycle').setState('min', 1);
      // 员工人数最小值是0
      viewmodel.get('peopleNum').setState('min', 0);
      // 注册资金最小值为0
      viewmodel.get('money').setState('min', 0);
      // 信用期限最小值是1
     	viewmodel.get('merchantExtend!creditServiceDay').setState('min', 1);
     	// 设置资质信息与企业性质无关的属性 切换时值 置空
     	const setEmptyAttr = (viewmodel) =>{
     		  viewmodel.get('creditCode').setValue("");
          viewmodel.get('address').setValue("");
          viewmodel.get('leaderName').setValue("");
          viewmodel.get('money').setValue("");
          viewmodel.get('currencyCode').setValue("");
          viewmodel.get('buildTime').setValue("");
          viewmodel.get('scope').setValue("");
     	}
      // 0 企业 1个人 2 非营利组织
      viewmodel.get('enterpriseNature').on('afterValueChange', () => {
      	viewmodel.get('frontIdNo').setValue('');
        viewmodel.get('backIdNo').setValue('');
        // 客户统一社会信用代码是否必输参数
      	let enterCustCreditCode = cb.rest.AppContext.option.enterCustCreditCode;
        // 个人客户身份证是否必输参数
      	let personalCustId = cb.rest.AppContext.option.personalCustId;
        if (viewmodel.get('enterpriseNature').getValue() == 0) {
          // 企业
          viewmodel.get('frontIdNo').setState('caption', "法人证件");
          viewmodel.get('enterpriseName').setVisible(true);
          //viewmodel.get('enterpriseName').setState('bIsNull', false);
          viewmodel.get('creditCode').setVisible(true);
    	    viewmodel.get('leaderNameIdNo').setVisible(true);
          viewmodel.get('leaderName').setVisible(true);
          viewmodel.get('businessLicense').setVisible(true);
          viewmodel.get('businessLicenseNo').setVisible(true);
          
          if(enterCustCreditCode){
            viewmodel.get('creditCode').setState('bIsNull', false);	
          }else {
          	viewmodel.get('creditCode').setState('bIsNull', true);	
          }
          viewmodel.get('idNo').setState('bIsNull', true);
          // 个人
          viewmodel.get('personName').setVisible(false);
          viewmodel.get('personName').setState('bIsNull', true);
          viewmodel.get('idNo').setVisible(false);
          
          viewmodel.get('personName').setValue('');
          viewmodel.get('idNo').setValue('');
          // 非营利组织
          viewmodel.get('orgName').setVisible(false);
          viewmodel.get('orgName').setState('bIsNull', true);
          viewmodel.get('personCharge').setVisible(false);
    	    viewmodel.get('personChargeIdNo').setVisible(false);
    	    viewmodel.get('orgIdNo').setVisible(false);
          
          //viewmodel.get('orgName').setValue('');
          viewmodel.get('personCharge').setValue('');
    	    viewmodel.get('personChargeIdNo').setValue('');
    	    viewmodel.get('orgIdNo').setValue('');
          //setEmptyAttr(viewmodel);
        } else if(viewmodel.get('enterpriseNature').getValue() == 1){
        	// 个人
        	viewmodel.get('frontIdNo').setState('caption', "证件");
        	viewmodel.get('personName').setVisible(true);
          viewmodel.get('personName').setState('bIsNull', false);
          viewmodel.get('idNo').setVisible(true);
          
          if(personalCustId){
            viewmodel.get('idNo').setState('bIsNull', false);	
          }else {
          	viewmodel.get('idNo').setState('bIsNull', true);	
          }
          viewmodel.get('creditCode').setState('bIsNull', true);
          // 企业 
          viewmodel.get('enterpriseName').setVisible(false);
          viewmodel.get('enterpriseName').setState('bIsNull', true);
          viewmodel.get('creditCode').setVisible(false);
    	    viewmodel.get('leaderNameIdNo').setVisible(false);
          viewmodel.get('leaderName').setVisible(false);
          viewmodel.get('businessLicense').setVisible(false);
          viewmodel.get('businessLicenseNo').setVisible(false);
          
          //viewmodel.get('enterpriseName').setValue('');
          viewmodel.get('creditCode').setValue('');
    	    viewmodel.get('leaderNameIdNo').setValue('');
          viewmodel.get('leaderName').setValue('');
          viewmodel.get('businessLicense').setValue('');
          viewmodel.get('businessLicenseNo').setValue('');
          // 非营利组织
          viewmodel.get('orgName').setVisible(false);
          viewmodel.get('orgName').setState('bIsNull', true);
          viewmodel.get('personCharge').setVisible(false);
    	    viewmodel.get('personChargeIdNo').setVisible(false);
    	    viewmodel.get('orgIdNo').setVisible(false);
    	    
    	    //viewmodel.get('orgName').setValue('');
          viewmodel.get('personCharge').setValue('');
    	    viewmodel.get('personChargeIdNo').setValue('');
    	    viewmodel.get('orgIdNo').setValue('');
    	    //setEmptyAttr(viewmodel);
        }else if(viewmodel.get('enterpriseNature').getValue() == 2){
        	// 非营利组织
        	viewmodel.get('frontIdNo').setState('caption', "负责人证件");
          viewmodel.get('orgName').setVisible(true);
          //viewmodel.get('orgName').setState('bIsNull', false);
          viewmodel.get('personCharge').setVisible(true);
    	    viewmodel.get('personChargeIdNo').setVisible(true);
    	    viewmodel.get('creditCode').setVisible(true);
    	    viewmodel.get('orgIdNo').setVisible(true);
    	    
    	    if(enterCustCreditCode){
            viewmodel.get('creditCode').setState('bIsNull', false);	
          }else {
          	viewmodel.get('creditCode').setState('bIsNull', true);	
          }
          viewmodel.get('idNo').setState('bIsNull', true);
    	    // 个人
    	    viewmodel.get('personName').setVisible(false);
          viewmodel.get('personName').setState('bIsNull', true);
          viewmodel.get('idNo').setVisible(false);
    	    
    	    viewmodel.get('personName').setValue('');
    	    viewmodel.get('idNo').setValue('');
    	    // 企业
    	    viewmodel.get('enterpriseName').setVisible(false);
          viewmodel.get('enterpriseName').setState('bIsNull', true);
    	    viewmodel.get('leaderNameIdNo').setVisible(false);
    	    viewmodel.get('leaderName').setVisible(false);
    	    viewmodel.get('businessLicense').setVisible(false);
          viewmodel.get('businessLicenseNo').setVisible(false);
          
          //viewmodel.get('enterpriseName').setValue('');
          viewmodel.get('creditCode').setValue('');
    	    viewmodel.get('leaderNameIdNo').setValue('');
          viewmodel.get('leaderName').setValue('');
          viewmodel.get('businessLicense').setValue('');
          viewmodel.get('businessLicenseNo').setValue('');
          //setEmptyAttr(viewmodel);
        }
      })
      
      // 当录入管理员信息时账号姓名和手机号必输
      viewmodel.get('merchantsManager!userName').on('afterValueChange', () => {
      	  if(viewmodel.get('merchantsManager!userName').getValue() != '' && viewmodel.get('merchantsManager!userName').getValue() != undefined
      	     ||(viewmodel.get('merchantsManager!mobile').getValue() != '' && viewmodel.get('merchantsManager!mobile').getValue() != undefined 
      	     ||viewmodel.get('merchantsManager!fullName').getValue() != '' && viewmodel.get('merchantsManager!fullName').getValue() != undefined )){
      	  	viewmodel.get('merchantsManager!userName').setState('bIsNull', false);
    	      viewmodel.get('merchantsManager!mobile').setState('bIsNull', false);
    	      viewmodel.get('merchantsManager!fullName').setState('bIsNull', false);
      	  	} else {
      	    viewmodel.get('merchantsManager!userName').setState('bIsNull', true);
    	      viewmodel.get('merchantsManager!mobile').setState('bIsNull', true);
    	      viewmodel.get('merchantsManager!fullName').setState('bIsNull', true);
    	      }
      	  	
      });
      viewmodel.get('merchantsManager!mobile').on('afterValueChange', () => {
      	 if(viewmodel.get('merchantsManager!mobile').getValue() != '' && viewmodel.get('merchantsManager!mobile').getValue() != undefined
      	     ||(viewmodel.get('merchantsManager!userName').getValue() != '' && viewmodel.get('merchantsManager!userName').getValue() != undefined 
      	     ||viewmodel.get('merchantsManager!fullName').getValue() != '' && viewmodel.get('merchantsManager!fullName').getValue() != undefined )){
      	 			 	viewmodel.get('merchantsManager!userName').setState('bIsNull', false);
    	          viewmodel.get('merchantsManager!mobile').setState('bIsNull', false);
    	          viewmodel.get('merchantsManager!fullName').setState('bIsNull', false);
      	 		}
      	 		else{
      	 				 	viewmodel.get('merchantsManager!userName').setState('bIsNull', true);
    	            viewmodel.get('merchantsManager!mobile').setState('bIsNull', true);
    	            viewmodel.get('merchantsManager!fullName').setState('bIsNull', true);
      	 			}
      
      });
      viewmodel.get('merchantsManager!fullName').on('afterValueChange', () => {
      		  if(viewmodel.get('merchantsManager!fullName').getValue() != '' && viewmodel.get('merchantsManager!fullName').getValue() != undefined
      	     ||(viewmodel.get('merchantsManager!userName').getValue() != '' && viewmodel.get('merchantsManager!userName').getValue() != undefined 
      	     ||viewmodel.get('merchantsManager!mobile').getValue() != '' && viewmodel.get('merchantsManager!mobile').getValue() != undefined )) {
      			 	viewmodel.get('merchantsManager!userName').setState('bIsNull', false);
    	        viewmodel.get('merchantsManager!mobile').setState('bIsNull', false);
    	        viewmodel.get('merchantsManager!fullName').setState('bIsNull', false);
      			}
      			else{
      				 	viewmodel.get('merchantsManager!userName').setState('bIsNull', true);
    	          viewmodel.get('merchantsManager!mobile').setState('bIsNull', true);
    	          viewmodel.get('merchantsManager!fullName').setState('bIsNull', true);
      				}
      	
      });
      
      viewmodel.get('internalOrg').on('afterValueChange', () => {
        if (viewmodel.get('internalOrg').getValue() == 'true') {
          viewmodel.get('orgId_Name').setVisible(true);
          viewmodel.get('orgId_Name').setValue('');
        } else {
          viewmodel.get('orgId_Name').setVisible(false);
          viewmodel.get('orgId_Name').setValue('');
        }
      })
      const checkID = (ID) => {
        //根据以上分析，给出省级地址码校验及测试程序如下：
        const checkProv = (val) => {
          let pattern = /^[1-9][0-9]/;
          let provs = {
            11: "北京",
            12: "天津",
            13: "河北",
            14: "山西",
            15: "内蒙古",
            21: "辽宁",
            22: "吉林",
            23: "黑龙江 ",
            31: "上海",
            32: "江苏",
            33: "浙江",
            34: "安徽",
            35: "福建",
            36: "江西",
            37: "山东",
            41: "河南",
            42: "湖北 ",
            43: "湖南",
            44: "广东",
            45: "广西",
            46: "海南",
            50: "重庆",
            51: "四川",
            52: "贵州",
            53: "云南",
            54: "西藏 ",
            61: "陕西",
            62: "甘肃",
            63: "青海",
            64: "宁夏",
            65: "新疆",
            71: "台湾",
            81: "香港",
            82: "澳门"
          };
          return !!(pattern.test(val) && provs[val])
        }
        // 出生日期码的校验不做解释， 直接给出如下函数及测试程序
        const checkDate = (val) => {
          let pattern = /^(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)$/;
          if (pattern.test(val)) {
            let year = val.substring(0, 4);
            let month = val.substring(4, 6);
            let date = val.substring(6, 8);
            let date2 = new Date(year + "-" + month + "-" + date);
            return date2 && date2.getMonth() == (parseInt(month) - 1)
          }
          return false;
        }
        //校验码计算程序及测试见如下代码
        const checkCode = (val) => {
          var p = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
          let factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
          let parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
          let code = val.substring(17);
          if (p.test(val)) {
            var sum = 0;
            for (var i = 0; i < 17; i++) {
              sum += val[i] * factor[i];
            }
            return parity[sum % 11] == code.toUpperCase()
          }
          return false;
        }
        const checkBase = (ID) => {
          return typeof ID === 'string' && ID.length === 18
        }
        return checkBase(ID) && checkCode(ID) && checkDate(ID.substring(6, 14)) && checkProv(ID.substring(0, 2))
      }
      viewmodel.on('beforeSave', (args) => {
      	let mode = viewmodel.getParams().mode
        let data = JSON.parse(args.data.data);
        let enterpriseNature = data.enterpriseNature;
        // 个人
        if (enterpriseNature == 1) {
          // 验证
          let idNo = data.idNo;
          if (!checkID(idNo)) {
            cb.utils.alert('资质信息-身份证号输入有误,请重新输入', 'error');
            return false
          }
        }
        let carryParams = viewmodel.getParams().carryParams;
        let { merchantApplyRangeId, isCreator, isApplied } = cb.rest.AppContext.query;
        if (merchantApplyRangeId && isCreator && isApplied) {
          data.merchantApplyRangeId = merchantApplyRangeId
          data.isCreator = typeBool(isCreator)
          data.isApplied = typeBool(isApplied)
        } else if (carryParams) {
          merchantApplyRangeId = carryParams.merchantApplyRangeId;
          isCreator = carryParams.isCreator;
          isApplied = carryParams.isApplied;
          if (merchantApplyRangeId) data.merchantApplyRangeId = merchantApplyRangeId;
          if (typeof isCreator == 'boolean') data.isCreator = isCreator;
          if (typeof isApplied == 'boolean') data.isApplied = isApplied;
        }
        // 判断资质信息下的联系人和联系电话是否同时不为空 
				if(viewmodel.get("contactName").getValue() != "" && viewmodel.get("contactName").getValue() != undefined && 
				    viewmodel.get("contactTel").getValue() != "" && viewmodel.get("contactTel").getValue() != undefined){
					data.contactName = viewmodel.get("contactName").getValue();
					data.contactTel = viewmodel.get("contactTel").getValue();
				}
        if (!diffcreator(viewmodel)) {
          data._status = 'Update';
          data['merchantExtend!_status'] = !data['merchantExtend!id'] ? 'Insert' : 'Update';
          //data = insertState(data);
        } else {
          if (mode === 'add') {
            data['source'] = 0
          }
        }
        args.data.data = JSON.stringify(data);
      })
      }
      // 当客户名称改变调用后台服务校验客户名称并返回客户信息回显页面
      viewmodel.get('name').on('afterValueChange', () => {
          var mnemonicCode = common.getMnemonicCode(viewmodel.get('name').getValue()); //得到数组
          var mnemonicCodeStr = "";
          for (var i = 0; i < mnemonicCode.length; i++) {
            var str = mnemonicCode[i] + ",";
            mnemonicCodeStr += str;
          }
          mnemonicCodeStr = mnemonicCodeStr.substring(0, mnemonicCodeStr.length - 1);
          viewmodel.get("merchantExtend!searchcode").setValue(mnemonicCodeStr);
          viewmodel.get('enterpriseName').setValue(viewmodel.get('name').getValue());
          viewmodel.get('orgName').setValue(viewmodel.get('name').getValue());
          viewmodel.get('shortname').setValue(viewmodel.get('name').getValue());
          viewmodel.get('enterpriseName').setDisabled(true);
          viewmodel.get('orgName').setDisabled(true);
          checkName(viewmodel);
      });
      const checkName =(viewmodel)=>{
      	let proxy = cb.rest.DynamicProxy.create({ _label: { url: '/merchant/checkName', method: 'POST' } });
      	let params = {name: viewmodel.get('enterpriseName').getValue()};
        proxy._label(params, (err, args) =>{
        	  if (err) {
            cb.utils.alert(err.message, 'error');
            viewmodel.get('creditCode').setValue("");
            viewmodel.get('address').setValue("");
            viewmodel.get('leaderName').setValue("");
            viewmodel.get('money').setValue("");
            viewmodel.get('currencyCode').setValue("");
            viewmodel.get('buildTime').setValue("");
            viewmodel.get('scope').setValue("");
            return false;
          }
          let merchantName = args.name||'';
          let creditCode = args.creditCode ||'';
          let address = args.address || '';
          let leaderName = args.leaderName || '';
          let money = args.money || '';
          let currencyCode = args.currencyCode || '';
          let buildTime = args.buildTime || '';
          let scope = args.scope || ''; 
          viewmodel.get('creditCode').setValue(creditCode);
          viewmodel.get('address').setValue(address);
          viewmodel.get('leaderName').setValue(leaderName);
          viewmodel.get('money').setValue(money);
          viewmodel.get('currencyCode').setValue(currencyCode);
          viewmodel.get('buildTime').setValue(buildTime);
          viewmodel.get('scope').setValue(scope);
         })
       }
    
      // 设置角色信息展示情况
      const checkRoleInfo =(viewmodel)=>{
      	let proxy = cb.rest.DynamicProxy.create({ _label: { url: '/api/upc/checkRegistInfo', method: 'POST' } });
      	// 系统应用编码 "systemCode":"URetail,UOrder,UMall" 删除标记 "isDeleted":0,租户id "tenant":616973480136960,
      	let tenant = cb.rest.AppContext.tenant.id;
      	let params = {tenant:tenant,systemCode:"URetail,UOrder,UMall",isDeleted:0 };
        proxy._label(params, (err, args) =>{
        	  if (err) {
            cb.utils.alert(err.message, 'error');
          } 
          if(args.length) {
          	  let lessLists=[];
              args.forEach((arg,i)=>{
              	if("URetail" == arg.systemCode && arg.total >0 ){
                lessLists.push({ value: '2', text: '零售加盟商' });
                lessLists.push({ value: '3', text: '零售终端客户' });
                viewmodel.get("merchantRole!businessRole").setDataSource(lessLists);
              	}
              	if("UOrder" == arg.systemCode && arg.total >0 ){
                lessLists.push({ value: '6', text: '订货入驻商家' });
                viewmodel.get("merchantRole!businessRole").setDataSource(lessLists);
              	}
              	if("UMall" == arg.systemCode && arg.total >0 ){
                lessLists.push({ value: '4', text: '商城入驻商家' });
                viewmodel.get("merchantRole!businessRole").setDataSource(lessLists);
              	}
        	});
          }else {
          	    viewmodel.execute('updateViewMeta', { code: '角色信息分组', visible: false });
                viewmodel.get("merchantRole!businessRole").setDataSource([{ value: '1', text: '客户' }]);
                viewmodel.get("merchantRole!businessRole").setDisabled(true);
          	}
         })
       }
       
      // 入住模式
      viewmodel.get('merchantRole!toBImmigrationMode').setVisible(false);
      viewmodel.get('orgId_Name').setVisible(false);
      // 结算周期最小是1
      viewmodel.get('merchantRole!settlementCycle').setState('min', 1);
      // 员工人数最小值是0
      viewmodel.get('peopleNum').setState('min', 0);
      // 注册资金最小值为0
      viewmodel.get('money').setState('min', 0);
      //1	客户 2	零售加盟商 3	零售终端客户 4	商城入驻商家 5	订货经销商(删除) 6	订货入驻商家
      viewmodel.get('merchantRole!businessRole').on('afterValueChange', () => {
        if (viewmodel.get('merchantRole!businessRole').getValue().includes("6")) {
          viewmodel.get('merchantRole!toBImmigrationMode').setVisible(true);
          viewmodel.get('merchantRole!toBImmigrationMode').setState('bIsNull', false);
          viewmodel.get('merchantRole!uOrderExpireDate').setVisible(true);
        } else {
          viewmodel.get('merchantRole!toBImmigrationMode').setVisible(false);
          viewmodel.get('merchantRole!uOrderExpireDate').setVisible(false);
          viewmodel.get('merchantRole!toBImmigrationMode').setState('bIsNull', true);
        }
        if(viewmodel.get('merchantRole!businessRole').getValue().includes("4")){
        	viewmodel.get('merchantRole!settlementMethod').setVisible(true);
    	    viewmodel.get('merchantRole!settlementCycle').setVisible(true);
    	    viewmodel.get('merchantRole!finalSettlementDate').setVisible(true);
    	    viewmodel.get('merchantRole!uMappExpireDate').setVisible(true);
    	    viewmodel.get('merchantRole!businessAccount').setVisible(true);
    	    viewmodel.get('merchantRole!cardOwnerName').setVisible(true);
    	    viewmodel.get('merchantRole!cardType').setVisible(true);
    	    viewmodel.get('merchantRole!receivingBank').setVisible(true);
        }else{
        	viewmodel.get('merchantRole!settlementMethod').setVisible(false);
    	    viewmodel.get('merchantRole!settlementCycle').setVisible(false);
    	    viewmodel.get('merchantRole!finalSettlementDate').setVisible(false);
    	    viewmodel.get('merchantRole!uMappExpireDate').setVisible(false);
    	    viewmodel.get('merchantRole!businessAccount').setVisible(false);
    	    viewmodel.get('merchantRole!cardOwnerName').setVisible(false);
    	    viewmodel.get('merchantRole!cardType').setVisible(false);
    	    viewmodel.get('merchantRole!receivingBank').setVisible(false);
    	    }
      })
      // 当录入管理员信息时账号姓名和手机号必输
      viewmodel.get('merchantsManager!userName').on('afterValueChange', () => {
      	  let aliasName = cb.rest.AppContext.tenant.alias;
      	 	viewmodel.get('merchantsManager!userName').setState('bIsNull', false);
    	    viewmodel.get('merchantsManager!mobile').setState('bIsNull', false);
    	    viewmodel.get('merchantsManager!fullName').setState('bIsNull', false);
    	    if(viewmodel.get('merchantsManager!userName').getValue() !='' &&viewmodel.get('merchantsManager!userName').getValue() !=undefined){
    	    	viewmodel.get('merchantsManager!userName').setValue(viewmodel.get('merchantsManager!userName').getValue()+"@"+aliasName);
    	    	}
      });
      viewmodel.get('merchantsManager!mobile').on('afterValueChange', () => {
      	 	viewmodel.get('merchantsManager!userName').setState('bIsNull', false);
    	    viewmodel.get('merchantsManager!mobile').setState('bIsNull', false);
    	    viewmodel.get('merchantsManager!fullName').setState('bIsNull', false);
      });
      viewmodel.get('merchantsManager!fullName').on('afterValueChange', () => {
      	 	viewmodel.get('merchantsManager!userName').setState('bIsNull', false);
    	    viewmodel.get('merchantsManager!mobile').setState('bIsNull', false);
    	    viewmodel.get('merchantsManager!fullName').setState('bIsNull', false);
      });
      
      viewmodel.get('internalOrg').on('afterValueChange', () => {
        if (viewmodel.get('internalOrg').getValue() == 'true') {
          viewmodel.get('orgId_Name').setVisible(true);
          viewmodel.get('orgId_Name').setValue('');
        } else {
          viewmodel.get('orgId_Name').setVisible(true);
          viewmodel.get('orgId_Name').setValue('');
        }
      })
      // 是否是创建者
    const diffcreator = (viewmodel) => {
         let isCreator = viewmodel.getParams().carryParams ? viewmodel.getParams().carryParams.isCreator : true;
         return typeBool(isCreator, true)
     }
      const insertState = (obj) => {
        obj && Object.keys(obj).forEach(value => {
        if (Array.isArray(obj[value])) {
           obj[value] = obj[value].map((val, index) => {
           val = val && insertState(val)
        if (val && val.id && val._status !== 'Delete') {
            val._status = 'Update'
        }
        return val
      })
    }
  })
  return obj
}
      const checkID = (ID) => {
        //根据以上分析，给出省级地址码校验及测试程序如下：
        const checkProv = (val) => {
          let pattern = /^[1-9][0-9]/;
          let provs = {
            11: "北京",
            12: "天津",
            13: "河北",
            14: "山西",
            15: "内蒙古",
            21: "辽宁",
            22: "吉林",
            23: "黑龙江 ",
            31: "上海",
            32: "江苏",
            33: "浙江",
            34: "安徽",
            35: "福建",
            36: "江西",
            37: "山东",
            41: "河南",
            42: "湖北 ",
            43: "湖南",
            44: "广东",
            45: "广西",
            46: "海南",
            50: "重庆",
            51: "四川",
            52: "贵州",
            53: "云南",
            54: "西藏 ",
            61: "陕西",
            62: "甘肃",
            63: "青海",
            64: "宁夏",
            65: "新疆",
            71: "台湾",
            81: "香港",
            82: "澳门"
          };
          return !!(pattern.test(val) && provs[val])
        }
        // 出生日期码的校验不做解释， 直接给出如下函数及测试程序
        const checkDate = (val) => {
          let pattern = /^(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)$/;
          if (pattern.test(val)) {
            let year = val.substring(0, 4);
            let month = val.substring(4, 6);
            let date = val.substring(6, 8);
            let date2 = new Date(year + "-" + month + "-" + date);
            return date2 && date2.getMonth() == (parseInt(month) - 1)
          }
          return false;
        }
        //校验码计算程序及测试见如下代码
        const checkCode = (val) => {
          var p = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
          let factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
          let parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
          let code = val.substring(17);
          if (p.test(val)) {
            var sum = 0;
            for (var i = 0; i < 17; i++) {
              sum += val[i] * factor[i];
            }
            return parity[sum % 11] == code.toUpperCase()
          }
          return false;
        }
        const checkBase = (ID) => {
          return typeof ID === 'string' && ID.length === 18
        }
        return checkBase(ID) && checkCode(ID) && checkDate(ID.substring(6, 14)) && checkProv(ID.substring(0, 2))
      }
    }
  }
  try {
    module.exports = AA_aa_merchant_VM_Extend;
  } catch (error) {

  }
  return AA_aa_merchant_VM_Extend;
});


// WEBPACK FOOTER //
// ./src/client/business/AA/AA_aa_merchant_VM.Extend.js